export default __webpack_public_path__ + "static/media/gallery-s-3.f97d7ab5.png";